import React, { Fragment, useContext, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControlLabel,
  Checkbox,
  Typography,
} from "@material-ui/core";

// Contexts
import AlertContext from "../../../../../../context/alert/AlertContext";
import OrderContext from "../../../../../../context/orders/v1/OrdersContext";

const useStyles = makeStyles((theme) => ({
  form: {
    display: "flex",
    flexWrap: "wrap",
  },
  headerBox: {
    fontSize: "0.9rem",
  },
  textField: {
    marginBottom: theme.spacing(2),
  },
  dialogActions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  button: {
    textTransform: "none",
  },
}));

const OrderTracking = ({ handleClose, currentFulfilled }) => {
  const classes = useStyles();

  const { setAlert } = useContext(AlertContext);
  const {
    modalFunction,
    modalValues,
    modalErrors,
    modalStates,
    setValues,
    setErrors,
    setModalStates,
    order,
    editOrderTracking,
  } = useContext(OrderContext);

  const handleChange = (e) => {
    const id = e.target.id;
    const value =
      e.target.id === "notify_customer" ? e.target.checked : e.target.value;

    let new_values = Object.assign({}, modalValues);

    new_values[id] = value;

    setValues(new_values);
  };

  const onSubmit = (e) => {
    e.preventDefault();

    // Check If Any Changes Made
    let new_changed = false;

    if (modalValues.tracking_number !== currentFulfilled.tracking_number) {
      new_changed = true;
    }

    if (new_changed) {
      setModalStates({
        submitted: true,
        changed: new_changed,
      });

      const fulfillment_id = currentFulfilled.id
        ? currentFulfilled.id
        : currentFulfilled.name;

      editOrderTracking(
        fulfillment_id,
        currentFulfilled.order_id,
        order.store_name,
        currentFulfilled.line_items,
        modalValues
      );
    } else {
      handleClose();
      setAlert("No changes has been made.", "info");
    }
  };

  useEffect(() => {
    if (modalFunction === "tracking") {
      setValues({
        tracking_number: currentFulfilled.tracking_number,
        tracking_company: currentFulfilled.tracking_company,
        notify_customer: true,
      });

      setErrors({
        tracking_number: null,
        tracking_company: null,
      });
    }
  }, [modalFunction]);

  return (
    modalFunction === "tracking" && (
      <Fragment>
        <DialogTitle> Edit tracking </DialogTitle>
        <DialogContent dividers>
          <form className={classes.form}>
            <TextField
              fullWidth
              className={classes.textField}
              label="Tracking number"
              id="tracking_number"
              value={
                modalValues.tracking_number ? modalValues.tracking_number : ""
              }
              onChange={handleChange}
            />
            <TextField
              fullWidth
              select
              SelectProps={{
                native: true,
              }}
              className={classes.textField}
              label="Shipping carrier"
              id="tracking_company"
              name="tracking_company"
              value={
                modalValues.tracking_company ? modalValues.tracking_company : ""
              }
              onChange={handleChange}
            >
              <option value="China Post"> China Post </option>{" "}
            </TextField>
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  id="notify_customer"
                  checked={
                    modalValues.notify_customer
                      ? modalValues.notify_customer
                      : false
                  }
                  onChange={handleChange}
                />
              }
              label={
                <Typography variant="body2" className={classes.headerBox}>
                  Send shipment details to your customer now{" "}
                </Typography>
              }
            />{" "}
          </form>{" "}
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={onSubmit}
            disabled={modalStates.submitted}
          >
            Save{" "}
          </Button>{" "}
          <Button
            variant="contained"
            className={classes.button}
            onClick={handleClose}
            disabled={modalStates.submitted}
          >
            Cancel{" "}
          </Button>{" "}
        </DialogActions>{" "}
      </Fragment>
    )
  );
};

export default OrderTracking;
